module.exports = __webpack_public_path__ + "static/img/埃菲尔铁塔.27206c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/模型库/埃菲尔铁塔.png
// module id = OxEt
// module chunks = 1